import React from 'react'
import ReactDOM from 'react-dom/client'
import { LookAndFeelProvider } from './components/LookAndFeelProvider'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/queryClient'
import { AuthProvider } from './context/AuthContext'
import App from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <LookAndFeelProvider>
        <BrowserRouter basename="">
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </LookAndFeelProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
